import React, { useState } from "react";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import HeroSection from "./components/HeroSection";
import { FeaturesSection } from "./components/FeaturesSection";
import TechnologySection from "./components/TechnologySection";

export default function App() {
  return (
    <div className="min-h-screen relative overflow-hidden flex flex-col">
      {/* Modern gradient background */}
      <div 
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(circle at 25% 25%, rgba(203, 108, 230, 0.15) 0%, transparent 50%),
            radial-gradient(circle at 75% 75%, rgba(203, 108, 230, 0.12) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(203, 108, 230, 0.08) 0%, transparent 50%),
            linear-gradient(135deg, #0f0a15 0%, #1a0f28 25%, #251a35 50%, #1a0f28 75%, #0f0a15 100%)
          `
        }}
      />
      
      {/* Floating geometric shapes */}
      <div className="absolute inset-0 overflow-hidden">
        <div 
          className="absolute w-96 h-96 rounded-full opacity-20"
          style={{
            background: 'radial-gradient(circle, rgba(203, 108, 230, 0.3) 0%, transparent 70%)',
            top: '5%',
            left: '5%',
            filter: 'blur(60px)',
            animation: 'float 25s ease-in-out infinite'
          }}
        />
        <div 
          className="absolute w-80 h-80 rounded-full opacity-15"
          style={{
            background: 'radial-gradient(circle, rgba(203, 108, 230, 0.4) 0%, transparent 70%)',
            top: '50%',
            right: '10%',
            filter: 'blur(80px)',
            animation: 'float 30s ease-in-out infinite reverse'
          }}
        />
        <div 
          className="absolute w-64 h-64 rounded-full opacity-10"
          style={{
            background: 'radial-gradient(circle, rgba(203, 108, 230, 0.5) 0%, transparent 70%)',
            bottom: '15%',
            left: '15%',
            filter: 'blur(40px)',
            animation: 'float 35s ease-in-out infinite'
          }}
        />
      </div>
      
      {/* Dynamic grid pattern */}
      <div className="absolute inset-0 opacity-8">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="modernGrid" width="80" height="80" patternUnits="userSpaceOnUse">
              <path d="M 80 0 L 0 0 0 80" fill="none" stroke="rgba(203, 108, 230, 0.15)" strokeWidth="1"/>
              <circle cx="40" cy="40" r="1.5" fill="rgba(203, 108, 230, 0.2)"/>
              <rect x="35" y="35" width="10" height="10" fill="none" stroke="rgba(203, 108, 230, 0.1)" strokeWidth="0.5"/>
            </pattern>
            <linearGradient id="modernGridGradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="rgba(203, 108, 230, 0.1)"/>
              <stop offset="50%" stopColor="rgba(203, 108, 230, 0.08)"/>
              <stop offset="100%" stopColor="rgba(203, 108, 230, 0.1)"/>
            </linearGradient>
          </defs>
          <rect width="100%" height="100%" fill="url(#modernGrid)" opacity="0.7"/>
          <rect width="100%" height="100%" fill="url(#modernGridGradient)" opacity="0.4"/>
        </svg>
      </div>

      {/* Animated particles */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 rounded-full opacity-30"
            style={{
              background: `linear-gradient(45deg, #cb6ce6, transparent)`,
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animation: `particle${i % 3} ${15 + Math.random() * 10}s linear infinite`,
              animationDelay: `${Math.random() * 5}s`
            }}
          />
        ))}
      </div>

      <Header />
      <main className="flex-1 container mx-auto px-4 pt-32 pb-12 max-w-7xl relative z-10 flex flex-col">
        <HeroSection />
        <FeaturesSection />
        <TechnologySection />
      </main>
      <Footer />

      <style dangerouslySetInnerHTML={{__html: `
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg) scale(1); }
          33% { transform: translateY(-30px) rotate(120deg) scale(1.1); }
          66% { transform: translateY(15px) rotate(240deg) scale(0.9); }
        }
        
        @keyframes particle0 {
          0% { transform: translateY(100vh) translateX(0px) rotate(0deg); opacity: 0; }
          10% { opacity: 0.3; }
          90% { opacity: 0.3; }
          100% { transform: translateY(-100vh) translateX(50px) rotate(360deg); opacity: 0; }
        }
        
        @keyframes particle1 {
          0% { transform: translateY(100vh) translateX(0px) rotate(0deg); opacity: 0; }
          10% { opacity: 0.3; }
          90% { opacity: 0.3; }
          100% { transform: translateY(-100vh) translateX(-30px) rotate(-360deg); opacity: 0; }
        }
        
        @keyframes particle2 {
          0% { transform: translateY(100vh) translateX(0px) rotate(0deg); opacity: 0; }
          10% { opacity: 0.3; }
          90% { opacity: 0.3; }
          100% { transform: translateY(-100vh) translateX(20px) rotate(180deg); opacity: 0; }
        }
      `}} />
    </div>
  );
}
